import React, { useState } from "react";
import { Button, Fade, Box } from "@mui/material";
import { Document, Page } from "react-pdf";
import api from "../../../api/axios";

const LoadPdf = ({ bookId, bookName }) => {
  //  Estados
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1); //
  const [scale, setScale] = useState(1.5);
  const [pdfFlag, setPdfFlag] = useState(false);

  //  Generar URL del PDF (con timestamp para evitar caché)
  const generatePdfUrl = (fileName) => {
    if (!fileName) return null;
    return `${
      process.env.REACT_APP_API_URL
    }/library/book?pdf=${fileName}&bookId=${bookId}&v=${Date.now()}`;
  };

  const [pdfUrl] = useState(() => generatePdfUrl(bookName));

  //  Zoom
  const zoomIn = () => setScale((prev) => prev + 0.1);
  const zoomOut = () => setScale((prev) => (prev > 0.6 ? prev - 0.1 : prev));

  //  Cuando se carga el PDF correctamente
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);

    // Desactivar después de 3 segundos
    setTimeout(() => {
      setPdfFlag(true);
    }, 2000);
  };

  //  Descargar PDF
  const handleDownloadPdf = async (fileName) => {
    try {
      const pdfBlob = await getPdfFile(fileName);
      const blobUrl = URL.createObjectURL(pdfBlob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("   Error al descargar PDF:", error);
    }
  };

  //  Obtener archivo desde API
  const getPdfFile = async (fileName) => {
    const url = generatePdfUrl(fileName);
    const response = await api.post(url, { responseType: "blob" });

    if (response.headers["content-type"] !== "application/pdf") {
      throw new Error("El servidor no devolvió un PDF válido");
    }

    return response.data;
  };

  return (
    <>
      {pdfUrl ? (
        <>
          {pdfFlag && numPages && pageNumber && (
            <Fade in timeout={2000}>
              <div className="pdf-viewer" style={{ width: "100%" }}>
                {/* Controles solo cuando está cargado */}
                <div style={{ width: "100%", padding: "10px" }}>
                  <div className="controls">
                    <h4 style={{ textAlign: "center" }}>Documento</h4>
                    <hr className="dividerClass" />
                    <p>
                      Página {pageNumber} de {numPages || "?"}
                    </p>
                    <Button
                      onClick={() => setPageNumber((p) => p - 1)}
                      disabled={pageNumber <= 1}>
                      Anterior
                    </Button>
                    <Button
                      onClick={() => setPageNumber((p) => p + 1)}
                      disabled={pageNumber >= numPages}>
                      Siguiente
                    </Button>
                    <Button onClick={zoomIn}>Zoom +</Button>
                    <Button onClick={zoomOut}>Zoom -</Button>
                    <Button onClick={() => handleDownloadPdf(bookName)}>
                      Descargar PDF
                    </Button>
                  </div>
                </div>

                {/* Documento se monta siempre */}
              </div>
            </Fade>
          )}
          <Document
            file={pdfUrl}
            onLoadSuccess={onDocumentLoadSuccess}
            noData="No se encontró el PDF."
            loading="Cargando PDF...">
            {pdfFlag && (
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Page
                  pageNumber={pageNumber}
                  scale={scale}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                />
              </Box>
            )}
          </Document>
        </>
      ) : (
        <div>No hay archivo PDF disponible.</div>
      )}
    </>
  );
};

export default LoadPdf;
